// extracted by mini-css-extract-plugin
export default {"TableText":"OperatorAlertList_TableText__+LNMX","ParentFlexContainer":"OperatorAlertList_ParentFlexContainer__zClgM"};